import { render, staticRenderFns } from "./OnboardingFeatureBasedOptions.vue?vue&type=template&id=e767b3fe&scoped=true"
import script from "./OnboardingFeatureBasedOptions.vue?vue&type=script&lang=js"
export * from "./OnboardingFeatureBasedOptions.vue?vue&type=script&lang=js"
import style0 from "./OnboardingFeatureBasedOptions.vue?vue&type=style&index=0&id=e767b3fe&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e767b3fe",
  null
  
)

export default component.exports